// removed by extract-text-webpack-plugin
module.exports = {"container":"tfpVo _38618 _3Dqep","deemphasized":"_2twtF","parameter":"_20z_B _38618 _3Dqep","nameInput":"_2i2x7 _38618 _3Dqep","fullscreen":"_2G87x","name":"_2m475 _3K4no","selected":"_2YcmO","noPopover":"pg3LL","isEditing":"_2AYUY","input":"_38Q_V","parameterButtons":"_2bHbr","editButton":"_3tq8o _38618 _3Dqep _1a-AI","removeButton":"_1kPst _38618 _3Dqep _1a-AI","editNameIconContainer":"_1oJCz"};


//////////////////
// WEBPACK FOOTER
// ./parameters/components/ParameterWidget.css
// module id = 264
// module chunks = 3 4 5